import React, { useEffect, useRef, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import classNames from 'classnames';
import './index.scss';

import {
    getConvertedCloudUrlBySettings,
    getImageSettings,
    imageExists,
    isBase64Image,
    isBase64Video
} from '../../../utils/image-util';
import {
    CROP_MODE,
    getCropModes,
    getGravityModes,
    getQualityModes,
    GRAVITY_MODE, imageFormats,
    QUALITY_MODE, videoFormats,
} from '../../../utils/enums';
import { getKeyByValue } from '../../../utils/objects-util';

import Dropdown from '../Dropdown';

const SettingImageEdit = ({ 
  t, 
  value, settings, 
  height, width,
  isShowSettings = true,
  disabled,
  onChange, onSettingsChange 
}) => {
    const fileInput = useRef();    
    const [image, setImage] = useState(value);

    const imageWidth = width || 350;
    const imageHeight = height || Math.trunc(imageWidth/parseFloat(1.5));
    const imageSettings = getImageSettings(settings);
    const imageValue = getConvertedCloudUrlBySettings(image, imageWidth, imageHeight,
      getKeyByValue(CROP_MODE, imageSettings.crop_mode),
      getKeyByValue(GRAVITY_MODE, imageSettings.gravity_mode),
      imageSettings.quality
    );
    const isEmpty = !imageValue;
    const valid = () => imageExists(imageValue);
    const isReadonly = () => disabled;
  
    const handleOnImageLoad = files => {
      if(disabled){
        return;
      }
      
      const file = files[0];

      if (!file || !(file.type.indexOf("image") < 0 || file.type.indexOf("video") < 0)) {
        toast.error(t("settings.AVATAR_LOADING_ERROR"));
        return;
      }

      const maxSize = 10 * 1024 * 1024; // 10mb
      if(file.size > maxSize) {
        toast.error(t("settings.MAXIMUM_MEDIA_SIZE"));
        return;
      }
  
      const fr = new FileReader();
      fr.onload = () => {
        if (fr.result) {
          setImage(fr.result);
          if (onChange) {
            onChange(fr.result);
          }
        }
      };
  
      fr.readAsDataURL(file);
    }

    const handleOnSettingsChange = (prop, value) => {
      onSettingsChange({ ...imageSettings, [prop]: value });
    }
  
    useEffect(()=> {
      if(value !== image) {
        setImage(value);
      }
    }, [value, image]);

    const isVideo = () => {
        return isBase64Video(image) || videoFormats.some(type => image.includes(type));
    }

    const isImage = () => {
        return isBase64Image(image) || imageFormats.some(type => image.includes(type));
    }

    return (
      <div className={classNames("settingImageEdit")}>        
        <div className={classNames("imageContainer")}>
          {image && valid() && isImage() && (
            <img src={imageValue} alt="imageEdit" className={classNames("imageEdit")} />
          )}

          {image && valid() && isVideo() && (
            <video controls className={classNames("videoEdit")}>
              <source src={imageValue}/>
            </video>
          )}

          {!image && <div className={classNames("imageEmpty")} />}
          {isEmpty && <div className={classNames("invalid")}>{t("basic.EMPTY_IMAGE_SOURCE")}</div>}
          {!isEmpty && !valid() && <div className={classNames("invalid")}>{t("basic.INVALID_IMAGE_SOURCE")}</div>}
        </div>        
        <div className={classNames("controlsContainer")}>
            {isShowSettings && (
              <div className={classNames("settings", { disabled: isReadonly() })}>
                <div className="setting">
                  <div className="title"></div>
                  <div className={classNames("editControl")}>
                    <div className={classNames("photo-img")}/>
                    <span className={classNames("editControlLabel")}>
                      {t("settings.personalSettings.personalSettings.AVATAR_CHANGE_BUTTON")}
                    </span>
                    <input ref={fileInput} disabled={disabled} type="file" onChange={e => handleOnImageLoad([...e.target.files])} />
                  </div>
                </div>
                <div className={classNames("setting")}>
                  <div className={classNames("title")}>{t("settings.CROP_MODE_LABEL")}</div>
                  <Dropdown readonly={isReadonly()} values={getCropModes()} value={getKeyByValue(CROP_MODE, imageSettings.crop_mode)}
                      onSelect={val => handleOnSettingsChange("crop_mode", val.key)}
                  />
                </div>
                <div className={classNames("setting")}>
                  <div className={classNames("title")}>{t("settings.GRAVITY_MODE_LABEL")}</div>
                  <Dropdown readonly={isReadonly()} values={getGravityModes()} value={getKeyByValue(GRAVITY_MODE, imageSettings.gravity_mode)}
                      onSelect={val => handleOnSettingsChange("gravity_mode", val.key)}
                  />
                </div>
                <div className={classNames("setting")}>
                  <div className={classNames("title")}>{t("settings.QUALITY_MODE")}</div>
                  <Dropdown readonly={isReadonly()} values={getQualityModes()} value={getKeyByValue(QUALITY_MODE, imageSettings.quality_mode)}
                      onSelect={val => handleOnSettingsChange("quality_mode", val.key)}
                  />
                </div>
                <div className={classNames("setting")}>
                <div className={classNames("title")}>{t("settings.QUALITY_MODE_LABEL")}</div>
                  <input readOnly={isReadonly()} value={imageSettings.quality} className={classNames("settingInput")}
                      onChange={e => handleOnSettingsChange("quality", parseInt(e.target.value))} 
                  />
                </div>
                {/*<div className={classNames("title maxMediaSize")}>{t("settings.MAXIMUM_MEDIA_SIZE")}</div>*/}
              </div>
            )}
        </div>
      </div>
    );
}

export default withTranslation()(SettingImageEdit);
